module.exports = __webpack_public_path__ + "img/LOGO_DOJO_Noir.66a60973.png";